var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FF5BB5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1663 15.0003V19.5837C24.1663 22.3337 22.333 24.167 19.583 24.167H10.4163C7.66634 24.167 5.83301 22.3337 5.83301 19.5837V15.0003C5.83301 12.507 7.33634 10.7653 9.67384 10.472C9.91217 10.4353 10.1597 10.417 10.4163 10.417H19.583C19.8213 10.417 20.0505 10.4261 20.2705 10.4628C22.6355 10.7378 24.1663 12.4887 24.1663 15.0003Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2724 10.4622C20.0524 10.4255 19.8233 10.4164 19.5849 10.4164H10.4183C10.1616 10.4164 9.91411 10.4347 9.67578 10.4713C9.80411 10.2147 9.98745 9.97635 10.2074 9.75635L13.1866 6.76801C14.4424 5.52134 16.4774 5.52134 17.7333 6.76801L19.3374 8.39053C19.9241 8.96803 20.2358 9.70134 20.2724 10.4622Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1663 15.458H21.4163C20.408 15.458 19.583 16.283 19.583 17.2913C19.583 18.2997 20.408 19.1247 21.4163 19.1247H24.1663",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryBag);
export default __webpack_public_path__ + "static/media/InventoryBag.a8963e02eb5dc1b9dffb7b330822a52d.svg";
export { ForwardRef as ReactComponent };